module.exports = __webpack_public_path__ + "img/logo_login.ffe269bd.png";